class ProductCardGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.observer = new IntersectionObserver(
      ([gallery]) => {
        if (!gallery.isIntersecting) return;

        this.observer.disconnect();
        this.init();
      },
      {
        rootMargin: "50% 50% 50% 50%",
      },
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  init() {
    this.querySelector(".product-card-gallery__inner").style.display = null;
    this.closest("product-card").classList.add("product-gallery-loaded");

    window.loadSwiper.then(({ Swiper }) => {
      const swiperParams = {
        slidesPerView: "auto",
        spaceBetween: 2,
        cssMode: true,
        navigation: {
          nextEl: this.querySelector("[data-navigation-next]"),
          prevEl: this.querySelector("[data-navigation-previous]"),
        },
      };

      this.swiper = new Swiper(this, swiperParams);
    });
  }
}

if (!customElements.get("product-card-gallery")) {
  customElements.define("product-card-gallery", ProductCardGallery);
}
